import { twMerge } from 'tailwind-merge'

/**
 * Combines multiple class names into a single string with intelligent Tailwind class conflict resolution
 * @param classes Array of class names, undefined values, or booleans
 * @returns A string of merged class names with conflicting utilities resolved
 */
export const classNames = (...classes: (string | undefined | boolean)[]) => {
  return twMerge(classes.filter(Boolean).join(" "));
};
